import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { WelcomePage } from './pages/WelcomePage';
import { MapPage } from './pages/MapPage';
import { SpotDetailPage } from './pages/SpotDetailPage';
import { RulesPage } from './pages/RulesPage';
import { RecommendationsPage } from './pages/RecommendationsPage';
import { ProfilePage } from './pages/ProfilePage';
import { BottomNav } from './components/navigation/BottomNav';
import { Sidebar } from './components/navigation/Sidebar';
import { useTheme } from './hooks/useTheme';
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const isWelcomePage = location.pathname === '/welcome';
  const isMapPage = location.pathname === '/';
  if (isWelcomePage) {
    return <>{children}</>;
  }
  return <div className="flex min-h-screen bg-background text-text transition-colors duration-300" data-id="element-0">
      <Sidebar data-id="element-1" />
      <main className={`flex-1 relative ${isMapPage ? 'h-screen overflow-hidden' : 'min-h-screen'} md:ml-64`} data-id="element-2">
        {children}
      </main>
      <BottomNav data-id="element-3" />
    </div>;
}
export function App() {
  // Initialize theme
  useTheme();
  return <BrowserRouter data-id="element-4">
      <Layout data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/welcome" element={<WelcomePage data-id="element-8" />} data-id="element-7" />
          <Route path="/" element={<MapPage data-id="element-10" />} data-id="element-9" />
          <Route path="/spot/:id" element={<SpotDetailPage data-id="element-12" />} data-id="element-11" />
          <Route path="/rules" element={<RulesPage data-id="element-14" />} data-id="element-13" />
          <Route path="/recommendations" element={<RecommendationsPage data-id="element-16" />} data-id="element-15" />
          <Route path="/profile" element={<ProfilePage data-id="element-18" />} data-id="element-17" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}